/* global axios */
import ApiClient from './ApiClient';

class BulkMessagesAPI extends ApiClient {
  constructor() {
    super('bulk_messages', { accountScoped: true });
  }

  sendNow(id) {
    return axios.post(`${this.url}/${id}/send_now`);
  }

  getRecipients(id) {
    return axios.get(`${this.url}/${id}/recipients`);
  }
}

export default new BulkMessagesAPI();
